
export default {
    path: 'journal',
    name: 'journalForm',
    component(){
        return import('@/components/journal/JournalForm.vue');
    },
    children: [
        {
            path: '',
            name: 'journalList',
            component() {
                return import('@/components/journal/JournalList.vue');
            },
        },
    ]
}